// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  box-sizing: border-box;
  overflow-x: clip;
  overflow-y: hidden;
}

body {
  margin: 0;
  font-size: 1rem;
  height: 100svh;
  overflow-y: scroll;
}

/* Print-specific styles */
@media print {
  body {
    /* Ensure the body is fully visible in print */
    overflow: visible !important;
    height: auto !important;
  }

  /* Handle page breaks */
  h1,
  p {
    page-break-inside: avoid;
  }

  /* Ensure any fixed or sticky elements don't interfere with print */
  .no-print {
    display: none; /* Hide elements not needed for printing */
  }
}

.OnlineBookingWrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  position: relative;
  height: inherit;
}

::-webkit-scrollbar {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE;IACE,8CAA8C;IAC9C,4BAA4B;IAC5B,uBAAuB;EACzB;;EAEA,uBAAuB;EACvB;;IAEE,wBAAwB;EAC1B;;EAEA,mEAAmE;EACnE;IACE,aAAa,EAAE,0CAA0C;EAC3D;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf","sourcesContent":["html {\n  box-sizing: border-box;\n  overflow-x: clip;\n  overflow-y: hidden;\n}\n\nbody {\n  margin: 0;\n  font-size: 1rem;\n  height: 100svh;\n  overflow-y: scroll;\n}\n\n/* Print-specific styles */\n@media print {\n  body {\n    /* Ensure the body is fully visible in print */\n    overflow: visible !important;\n    height: auto !important;\n  }\n\n  /* Handle page breaks */\n  h1,\n  p {\n    page-break-inside: avoid;\n  }\n\n  /* Ensure any fixed or sticky elements don't interfere with print */\n  .no-print {\n    display: none; /* Hide elements not needed for printing */\n  }\n}\n\n.OnlineBookingWrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  position: relative;\n  height: inherit;\n}\n\n::-webkit-scrollbar {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
